<div class="dialogContainerLeft generatedHTMLWindow generatedHTMLForm angularForm " [formGroup]="formData">
  <table aria-hidden="true">
    <tbody>
      <tr>
        <td class="LabelContainer dialogTableCellPaddingTop">
          <span class="dialogLabel uppercase">{{ 'valuationPortfolio.puid' | translate }}</span>
        </td>
        <td style="width:20px;"></td>
      </tr>
      <tr>
        <td class="FieldContainer">
          <p>{{copyValuationPortfolioData.ProjectIDDescription}}</p>
        </td>
      </tr>
      <tr>
        <td class="LabelContainer dialogTableCellPaddingTop">
          <span class="dialogLabel uppercase">{{ 'valuationPortfolio.periodOfValuation' | translate }}</span>
        </td>
      </tr>
      <tr>
        <td class="fieldContainer">
          <kendo-dropdownlist formControlName="PeriodOfValuationID"
                              [data]="periodofvaluation"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              id="form-periodOfValuation"
                              (valueChange)="checkRequiredFieldsForValuationPortfolioName()">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr *ngIf="formData.controls?.PeriodOfValuationID.value == 2">
        <td class="LabelContainer dialogTableCellPaddingTop">
          <span class="dialogLabel uppercase">{{ 'valuationPortfolio.valuationDueDate' | translate }}</span>
        </td>
      </tr>
      <tr *ngIf="formData.controls?.PeriodOfValuationID.value == 2" class="generatedHTMLForm ">
        <td class="FieldContainer">
          <kendo-datepicker formControlName="ValuationDate"
                            id="form-datePickerValuationDate"
                            [ngClass]="{ invalid: valuationDateInvalid }">
          </kendo-datepicker>
        </td>
      </tr>
      <tr *ngIf="formData.controls?.PeriodOfValuationID.value == 3">
        <!--neuer Eintrag "zur bestehenden Bewertungsperiode hinzufügen"-->
        <td class="FieldContainer">
          <kendo-combobox formControlName="ValuationPeriodId"
                          [data]="availableValuationPeriods"
                          style="width: 100%">
          </kendo-combobox>
        </td>
      </tr>
      <tr *ngIf="formData.controls?.PeriodOfValuationID.value == 1 || formData.controls?.PeriodOfValuationID.value == 3">
        <td class="FieldContainer">
          <div class="align-items-center">
            <input class="width-auto"
                   type="radio"
                   id="divisionOfPortfolio"
                   formControlName="DivisionOfPortfolio"
                   (change)="checkRequiredFieldsForValuationPortfolioName()"
                   value="DivisionOfPortfolio">
            <label class="dialogLabel" style="text-transform: uppercase" for="divisionOfPortfolio">{{ 'valuationPortfolio.divisionOfPortfolio' | translate }}</label>
          </div>
          <div class="align-items-center">
            <input class="width-auto"
                   type="radio"
                   id="scenario"
                   formControlName="DivisionOfPortfolio"
                   (change)="checkRequiredFieldsForValuationPortfolioName()"
                   value="Scenario">
            <label class="dialogLabel" style="text-transform: uppercase" for="scenario">{{ 'valuationPortfolio.scenario' | translate }}</label>
          </div>
        </td>
      </tr>
      <tr>
        <td class="FieldContainer">
          <input type="checkbox" id="refreshValuationDueDate"
                 class="k-checkbox"
                 formControlName="refreshValuationDueDate">
          <label class="k-checkbox-label k-checkbox-label-uppercase dialogLabel" for="refreshValuationDueDate">{{ 'valuationPortfolio.refreshValuationDueDate' | translate }}</label>
        </td>
      </tr>
      <tr>
        <td class="LabelContainer dialogTableCellPaddingTop">
          <span class="dialogLabel uppercase">{{ 'projectValuation.clientManual' | translate }}</span>
        </td>
      </tr>
      <tr>
        <td class="FieldContainer">
          <input type="text"
                 class="k-input k-textbox"
                 formControlName="ClientManual"
                 (change)="checkRequiredFieldsForValuationPortfolioName()"
                 id="form-clientmanual" />
        </td>
      </tr>
      <tr>
        <td class="LabelContainer dialogTableCellPaddingTop">
          <span class="dialogLabel uppercase">{{ 'valuationPortfolio.projectName' | translate }}</span>
        </td>
      </tr>
      <tr>
        <td class="FieldContainer">
          <input class="k-input k-textbox"
                 style="width:100%"
                 formControlName="ProjectName"
                 (change)="checkRequiredFieldsForValuationPortfolioName()" />
        </td>
      </tr>
      <tr>
        <td class="LabelContainer dialogTableCellPaddingTop">
          <span class="dialogLabel uppercase">{{ 'valuationPortfolio.remark' | translate }}</span>
        </td>
      </tr>
      <tr>
        <td class="FieldContainer">
          <textarea type="text" rows="5" class="k-textbox"
                    style="height:22px !important; overflow: auto; width: 100%"
                    formControlName="Remark"
                    (onChange)="checkRequiredFieldsForValuationPortfolioName()"
                    [ngClass]="{ invalid: copyValuationPortfolioData?.Remark == originalData?.Remark }"></textarea>
        </td>
      </tr>
      <tr>
        <td class="LabelContainer dialogTableCellPaddingTop">
          <span class="dialogLabel uppercase">{{ 'valuationPortfolio.valuationPortfolioName' | translate }}</span>
        </td>
      </tr>
      <tr>
        <td class="FieldContainer">
          <textarea rows="4"
                    class="k-textbox"
                    style="overflow: auto; width:100%"
                    formControlName="ValuationPortfolioName"></textarea>
        </td>
      </tr>
      <tr *ngIf="formData.disabled">
        <td>
          <label><span class="dialogLabel uppercase">{{ 'valuationPortfolio.countProperties' | translate }}</span></label>
          <p>{{propertiesCount}}</p>
        </td>
      </tr>
    </tbody>
  </table>
</div>
